module.exports = "<p>TODO</p>"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/extrainfopopup.html
// module id = 524
// module chunks = 0